// Widget CSS
import '@/css/_elementor/widgets/blog_grid.css';

// ..........................................................................................

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/blog_grid.default', (scope) => {
		const scopeEl = scope[0];

		// ...

		scopeEl.querySelectorAll('.search-filter-input-text').forEach((wrapper) => {
			const input = wrapper.querySelector('.search-filter-input-text__input');
			const icon = wrapper.querySelector('.search-filter-input-text__icon');
			if (input && icon && input.nextElementSibling !== icon) {
				input.insertAdjacentElement('afterend', icon);
			}
		});

		// ...

		const input = document.querySelector('.search-filter-field--control-type-sort input.search-filter-component-combobox__actions-input');
		if (input) {
			input.addEventListener('focus', (e) => e.target.blur());
		}

		// ...
	});
});

// ..........................................................................................

// window.addEventListener('elementor/frontend/init', () => {
// 	if (!elementorFrontend?.isEditMode()) {
// 		// ...

// 		const lenis = new Lenis({
// 			autoRaf: true,
// 			lerp: 0.12,
// 			prevent: (node) => node.classList.contains('search-filter-component-combobox-base__listbox'),
// 		});

// 		// ...

// 		const headerEl = document.querySelector('.elementor-location-header > .header-container');
// 		const scrollTarget = document.querySelector('.posts-toolbar');

// 		if (!headerEl || !scrollTarget) return;

// 		// ...

// 		document.addEventListener('click', (event) => {
// 			const clickedEl = event.target.closest('.posts-pagination a, .post-categories a, .post-categories button');

// 			if (clickedEl) {
// 				const scrollOffset = window.innerWidth < 768 ? -140 : -148;

// 				lenis.scrollTo(scrollTarget, {
// 					offset: scrollOffset,
// 					lerp: 0.5,
// 					force: true,
// 					lock: true,
// 				});
// 			}
// 		});

// 		// ...
// 	} // end if (!elementorFrontend?.isEditMode())
// });

// ..........................................................................................
